import React, { Component } from 'react'

export default class FooterContent extends Component {
    constructor(props){
        super(props)
    }

    render() {
        return (
            <div className = { this.props.className ? `footercontent ${this.props.className}` : "footercontent"}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FooterContent.js